import { DataList, DataListItem } from '@brighte/form-components';
import { LABELS } from '@utils';

interface FeeChargeDetailsProps {
  data?: DataListItem[];
}
function FeeChargeDetails({ data }: FeeChargeDetailsProps) {
  if (!data) {
    return null;
  }
  return <DataList title={LABELS.FEES_AND_CHARGES} items={data} />;
}

export default FeeChargeDetails;
